var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[_c('a',{attrs:{"href":"/account/dashboard"}},[_c('span',{staticClass:"avatar__button",class:{ 'active': _vm.isDashboardPage }},[_c('p',{staticClass:"avatar__button-text",domProps:{"textContent":_vm._s(_vm.userInitials)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }